import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { TIPOS_DEFEITO, NIVEIS_DIFICULDADE, ConsertoDados } from "@/constants/consertos";

interface ConsertoSectionProps {
  data: ConsertoDados;
  onChange: (data: ConsertoDados) => void;
  orderType: string;
}

export function ConsertoSection({ data, onChange, orderType }: ConsertoSectionProps) {
  if (orderType !== "conserto" && orderType !== "ajuste") {
    return null;
  }

  const handleChange = (field: keyof ConsertoDados, value: any) => {
    onChange({ ...data, [field]: value });
  };

  return (
    <div className="space-y-4">
      {/* Header minimalista */}
      <div className="flex items-center gap-2 mb-4">
        <span className="text-sm font-semibold text-gray-700">🔧 Detalhes do {orderType === "conserto" ? "Conserto" : "Ajuste"}</span>
      </div>

      {/* Material do Cliente */}
      <div className="flex items-center gap-3">
        <Checkbox
          id="materialCliente"
          checked={data.materialCliente}
          onCheckedChange={(checked) => handleChange("materialCliente", checked)}
        />
        <Label htmlFor="materialCliente" className="text-sm cursor-pointer">
          Material trazido pelo cliente
        </Label>
      </div>

      {/* Grid 2 colunas */}
      <div className="grid grid-cols-2 gap-4">
        {/* Tipo de Defeito */}
        <div className="space-y-1">
          <Label htmlFor="tipoDefeito" className="text-sm font-medium">Tipo de Defeito</Label>
          <Select value={data.tipoDefeito} onValueChange={(value) => handleChange("tipoDefeito", value)}>
            <SelectTrigger id="tipoDefeito" className="h-9">
              <SelectValue placeholder="Selecione..." />
            </SelectTrigger>
            <SelectContent>
              {TIPOS_DEFEITO.map((tipo) => (
                <SelectItem key={tipo.value} value={tipo.value}>
                  {tipo.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        {/* Nível Dificuldade */}
        <div className="space-y-1">
          <Label htmlFor="nivelDificuldade" className="text-sm font-medium">Dificuldade</Label>
          <Select value={data.nivelDificuldade} onValueChange={(value) => handleChange("nivelDificuldade", value)}>
            <SelectTrigger id="nivelDificuldade" className="h-9">
              <SelectValue placeholder="Selecione..." />
            </SelectTrigger>
            <SelectContent>
              {NIVEIS_DIFICULDADE.map((nivel) => (
                <SelectItem key={nivel.value} value={nivel.value}>
                  {nivel.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>

      {/* Grid 2 colunas */}
      <div className="grid grid-cols-2 gap-4">
        {/* Área Afetada */}
        <div className="space-y-1">
          <Label htmlFor="areiaAfetada" className="text-sm font-medium">Área Afetada</Label>
          <Input
            id="areiaAfetada"
            placeholder="Ex: Costado, Manga..."
            value={data.areiaAfetada}
            onChange={(e) => handleChange("areiaAfetada", e.target.value)}
            className="h-9"
          />
        </div>

        {/* Data Entrada */}
        <div className="space-y-1">
          <Label htmlFor="dataEntrada" className="text-sm font-medium">Data de Entrada</Label>
          <Input
            id="dataEntrada"
            type="date"
            value={data.dataEntrada}
            onChange={(e) => handleChange("dataEntrada", e.target.value)}
            className="h-9"
          />
        </div>
      </div>

      {/* Descrição (full width) */}
      <div className="space-y-1">
        <Label htmlFor="descricaoDefeito" className="text-sm font-medium">Descrição do Defeito</Label>
        <Textarea
          id="descricaoDefeito"
          placeholder="Descreva o problema..."
          value={data.descricaoDefeito}
          onChange={(e) => handleChange("descricaoDefeito", e.target.value)}
          rows={2}
          className="text-sm"
        />
      </div>

      {/* Observações (full width) */}
      <div className="space-y-1">
        <Label htmlFor="observacoes" className="text-sm font-medium">Observações</Label>
        <Textarea
          id="observacoes"
          placeholder="Notas adicionais..."
          value={data.observacoes}
          onChange={(e) => handleChange("observacoes", e.target.value)}
          rows={2}
          className="text-sm"
        />
      </div>
    </div>
  );
}
